module.exports = __webpack_public_path__ + "static/media/screen-pro.16cec5a3.svg";